import type { ReactNode } from 'react';

/**
 * One group of a task page (Overdue, This week…): a card whose first row is drawn like a record
 * table's header row, so its label lines up with the rows under it as a list's columns do.
 */
export function TaskGroup({
  name,
  count,
  children,
}: {
  name: string;
  count: number;
  children: ReactNode;
}) {
  return (
    <section
      data-testid={`task-group-${name}`}
      className="bg-card border-border rounded-card shadow-card overflow-hidden border"
    >
      <h3 className="bg-muted text-muted-foreground px-4 py-3 shadow-[inset_0_-1px_0_var(--color-border)] text-xs font-semibold">
        {name} · {count}
      </h3>
      <ul className="divide-border divide-y">{children}</ul>
    </section>
  );
}
